import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface OrphanTasksBannerProps {
  count: number;
  onGoToInbox: () => void;
  visible?: boolean;
  teamScope?: boolean;
}

export function OrphanTasksBanner({
  count,
  onGoToInbox,
  visible = true,
  teamScope = false,
}: OrphanTasksBannerProps) {
  if (!visible || count <= 0) return null;

  const title = teamScope
    ? `${count} tarefa${count !== 1 ? "s" : ""} da equipe sem projeto`
    : `${count} tarefa${count !== 1 ? "s" : ""} sua${count !== 1 ? "s" : ""} sem projeto`;

  return (
    <Alert variant="default" className="shrink-0 border-amber-500/40 bg-amber-500/5 py-2 px-3">
      <AlertTriangle className="h-3.5 w-3.5 text-amber-600" />
      <AlertTitle className="text-sm text-amber-800 dark:text-amber-200">{title}</AlertTitle>
      <AlertDescription className="flex flex-col sm:flex-row sm:items-center gap-2 sm:justify-between">
        <span className="text-xs text-muted-foreground">
          {teamScope
            ? "Órfãs de todos os membros ficam em Gerais na aba Equipe. Atribua-as a um projeto para usar o Kanban."
            : "Suas tarefas legadas ficam em Gerais. Atribua-as a um projeto quando quiser usar o Kanban."}
        </span>
        <Button variant="outline" size="sm" onClick={onGoToInbox} className="shrink-0 h-7 text-xs">
          Ver Gerais
        </Button>
      </AlertDescription>
    </Alert>
  );
}
